import React from 'react';
import ContactPageLayout from '../components/ContactPage/ContactPageLayout';

const Contact: React.FC = () => <ContactPageLayout />;

export default Contact;
